






















































import Vue from 'vue'
import AbpBase from '../../../lib/abpbase'
import { Component } from 'vue-property-decorator'
import OrderApi from '@/api/marketing/couponpack/index'
import ShippingCompany from '@/api/shipping/index'
import CustomForm from '@/components/custom-form/index.vue'
import areaList from '@/lib/area'
@Component({
  components: {
    CustomForm,
  },
})
export default class CouponPackOrderDetails extends AbpBase {
  stepList: any[] = [
    { title: '待支付', content: '' },
    { title: '已完成', content: '' },
    { title: '已取消', content: '' },
  ]
  currentStep = 0
  columnsProductinfo: any[] = [
    {
      title: '优惠券名称',
      key: 'couponName',
      align: 'center',
    },
    {
      title: '订单号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '数量',
      key: 'quantity',
      align: 'center',
    },
  ]
  columnsActioninfo: any[] = [
    {
      title: '操作人账号',
      key: 'userName',
      align: 'center',
    },
    {
      title: '操作时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '订单状态',
      key: 'orderStatus',
      align: 'center',
    },
    {
      title: '付款状态',
      key: 'paymentStatus',
      align: 'center',
    },
    {
      title: '发货状态',
      key: 'shippingStatus',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]
  orderDetail: any = {}
  orderNoteList = []

  get orderItems() {
    return this.orderDetail.orderItems ? this.orderDetail.orderItems : []
  }

  created() {
    if (this.$route.query['id']) {
      this.getOrderDetail()
      // this.getOrderNote()
    }
  }

  /**
   * 订单详情
   */
  getOrderDetail() {
    let id = this.$route.query['id'].toString()
    OrderApi.getCouponOrderDetail(id).then((res) => {
      this.orderDetail = res.data
      this.currentStep = res.data.orderStatus
      // this.stepList[0].content = this.orderDetail.creationTime
      // this.stepList[1].content = this.orderDetail.payTime
      // this.stepList[2].content = this.orderDetail.deliveryTime
    })
  }

  /**
   * 获取订单操作日志
   */
  getOrderNote() {
    let id = this.$route.query['id'].toString()
    OrderApi.getOrderNote(id).then((res) => {
      this.orderNoteList = res.data.items
    })
  }

}
